import * as React from 'react'
import {createFileRoute, Link} from '@tanstack/react-router';
import {getSystemGroups} from '@/services';
import {SYSTEMS_STALE_TIME_5_MINS} from '@/config';
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query';
import {LoadingScreen} from '@/components/molecules/LoadingScreen.tsx';
import { ErrorComponent } from '@/components/molecules/ErrorComponent';
import { generateUrl } from '@/components/helpers/systemHelpers';

const systemsQueryOptions = queryOptions({
  queryKey: ['systems'],
  queryFn: getSystemGroups,
  staleTime: SYSTEMS_STALE_TIME_5_MINS,
});

export const Route = createFileRoute('/systems/')({
  loader: async ({ context }) => {
    return context.queryClient?.ensureQueryData(systemsQueryOptions);
  },
  pendingComponent: LoadingScreen,
  component: Index,
});

function Index() {
  const { error, data } = useSuspenseQuery(systemsQueryOptions);

  if(error) {
    return(<ErrorComponent error={error} />)
  }
  if(data) {
    if(data.length === 0) {
      return(<ErrorComponent error={new Error('No systems found!')} />);
    }
    return (
      <div className="flex flex-row flex-wrap">
        {data.map(group => (
          <div key={group._id} className="basis-full flex-none md:basis-1/2 xl:basis-1/3 p-8 min-h-[150]">
            <Link to={generateUrl(group)}>
              <h3 className="text-3xl font-thin">{group.name}</h3>
              <div className="mt-4">{group.description}</div>
            </Link>
          </div>
        ))}
      </div>
    )
  }

}
